import { getMetafield } from 'src/functions/util/getMetafield'

import type { BreadcrumbItem } from 'src/components/Breadcrumbs/Breadcrumbs'
import type { Collection } from 'src/data/graphql-generated'
import type { Language } from 'src/enum/Language'
import type { CollectionBreadcrumb } from 'src/types/Collection'

const isCollection = (b: Collection | CollectionBreadcrumb): b is Collection => 'metafields' in b

export const generateBreadcrumbs = (
  breadcrumbsCollections: (Collection | CollectionBreadcrumb | undefined)[],
  language: Language,
): BreadcrumbItem[] | [] => {
  if (breadcrumbsCollections.length === 0) return []

  const generated: BreadcrumbItem[] | [] = breadcrumbsCollections
    .filter((b): b is Collection | CollectionBreadcrumb => Boolean(b))
    .flatMap((breadcrumb) => {
      if (isCollection(breadcrumb)) {
        const pageType = getMetafield(breadcrumb.metafields, 'layout', 'page_type')
        return [
          {
            title: breadcrumb.title,
            href: `/${language}/${pageType === 'coffee' ? 'c' : 'g'}/${breadcrumb.handle}`,
          },
        ]
      }

      return {
        title: breadcrumb.title,
        href: breadcrumb.url,
      }
    })

  return generated
}
